module.exports = __webpack_public_path__ + "img/receipt02.f050bc18.jpg";